<template>
  <label :class="{ 'p-error': invalid, 'p-disabled': disabled }" v-if="!hideLabel" class="mr-1">{{ label }}</label>
  <InputNumber
    ref="inputEl"
    v-model="value"
    :placeholder="placeholder"
    :min="min"
    :step="step"
    :max="max"
    mode="decimal"
    :minFractionDigits="0"
    :maxFractionDigits="decimal ? 2 : 0"
    :format="decimal"
    :disabled="disabled"
    :style="style"
    @blur="$emit('blur')"
    :class="{ 'p-invalid': invalid }"
    :show-buttons="showButtons"
    button-layout="horizontal"
  >
    <template #incrementbuttonicon>
      <span class="pi pi-plus" />
    </template>
    <template #decrementbuttonicon>
      <span class="pi pi-minus" />
    </template>
  </InputNumber>
  <template v-if="error && showErrors">
    <small v-if="typeof error === 'string'" class="p-error">{{ error }}</small>
    <template v-else-if="typeof error === 'object' && error.length">
      <template v-for="errorObj in error">
        <small class="p-error">{{ errorObj.$message }}</small>
      </template>
    </template>
  </template>
</template>

<script>
export default {
  name: "NumberInput",
  props: {
    modelValue: Number,
    label: {
      type: String,
      required: true
    },
    placeholder: {
      type: String,
      default: ''
    },
    error: {
      default: null
    },
    hideLabel: {
      type: Boolean,
      default: false
    },
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number
    },
    step: {
      type: Number,
      default: 0.1
    },
    decimal: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    invalid: {
      type: Boolean,
      default: false
    },
    showErrors: {
      type: Boolean,
      default: true
    },
    autofocus: {
      type: Boolean,
      default: false
    },
    showButtons: {
      type: Boolean,
      default: false
    },
    style: {
      type: String,
      default: 'width: 100%'
    },
  },
  emits: ['update:modelValue', 'blur'],
  mounted() {
    if (this.autofocus) this.$refs.inputEl.$el.children[0].focus();
  },
  computed: {
    value: {
      get() {
        return this.modelValue
      },
      set(value) {
        this.$emit('update:modelValue', value)
      }
    }
  }
}
</script>

<style>
.p-inputnumber-buttons-horizontal .p-inputnumber-input {
  border-radius: 0 !important;
}
</style>
